/**
 * COTI-633: mensajes de error cuando el pliego (ancho/largo, en mm) supera lo que admite
 * una máquina. Compartido por input_suaje.vue (aviso bajo las medidas del pliego) e
 * input_procesos_item.vue (aviso junto al selector de máquina de cada proceso) — misma
 * lógica, dos lugares donde el usuario puede necesitar verla.
 *
 * Ancho y largo son chequeos independientes — se devuelven por separado (no como un único
 * texto combinado) para que ancho-vs-máximo y largo-vs-máximo puedan reportarse como dos
 * mensajes distintos, no uno solo con las dos líneas adentro.
 *
 * @param {object} params
 * @param {number} params.anchoPliego Ancho del pliego cargado, en mm.
 * @param {number} params.largoPliego Largo del pliego cargado, en mm.
 * @param {number} params.anchoMaximo Ancho máximo de la máquina, en mm (0 = sin configurar, no valida).
 * @param {number} params.largoMaximo Largo máximo de la máquina, en mm (0 = sin configurar, no valida).
 * @returns {{ ancho: string|null, largo: string|null }}
 */
export function calcularErrorMaximoMaquinaPliego({
  anchoPliego,
  largoPliego,
  anchoMaximo,
  largoMaximo,
}) {
  const ancho =
    anchoMaximo > 0 && anchoPliego > anchoMaximo
      ? `El ancho del pliego (${anchoPliego.toFixed(2)} mm) supera el ancho máximo de la máquina (${anchoMaximo.toFixed(2)} mm).`
      : null;
  const largo =
    largoMaximo > 0 && largoPliego > largoMaximo
      ? `El largo del pliego (${largoPliego.toFixed(2)} mm) supera el largo máximo de la máquina (${largoMaximo.toFixed(2)} mm).`
      : null;
  return { ancho, largo };
}

/**
 * Si una medida del pliego (ancho o largo) no llega al mínimo requerido. Compartida por
 * medida_pliego.vue (aviso bajo el campo) e input_suaje.vue (reporte al registro de errores,
 * COTI-633) — misma condición para las dos cosas, no debe evaluarse distinto en cada lugar.
 *
 * Ambos valores deben venir en la misma unidad (mm o in, la que esté activa en pantalla). Un
 * valor sin cargar (0) no dispara el aviso: todavía no hay nada que comparar.
 *
 * @param {object} params
 * @param {number} params.medida Valor cargado en el campo.
 * @param {number} params.minimo Mínimo requerido.
 * @returns {boolean}
 */
export function noLlegaAlMinimoPliego({ medida, minimo }) {
  const valorMedida = Number(medida ?? 0);
  const valorMinimo = Number(minimo ?? 0);
  return valorMedida > 0 && valorMinimo > 0 && valorMedida < valorMinimo;
}
